import { useSearchParams } from "react-router-dom";
import FanchaLayout from "@/components/feature/FanchaLayout";
import useSeo from "@/hooks/useSeo";
import { SITE_NAME, SITE_SLOGAN, cases, siteFaqs } from "@/mocks/fancha";
import Hero from "./components/Hero";
import CasesSection from "./components/CasesSection";
import RankSection from "./components/RankSection";
import MethodSection from "./components/MethodSection";
import LatestSection from "./components/LatestSection";
import FaqSection from "./components/FaqSection";
import ContributeSection from "./components/ContributeSection";

export default function Home() {
  const [searchParams, setSearchParams] = useSearchParams();
  const cat = searchParams.get("cat") ?? "all";
  const q = searchParams.get("q") ?? "";

  useSeo({
    title: "反差吃瓜 | 反差吃瓜人设反转深扒，反差吃瓜当事人前后对比",
    description:
      "反差吃瓜局专注反差吃瓜人设反转、身份揭秘与当事人前后对比。深扒人设反转来龙去脉，看清当事人真面目，讲逻辑讲证据，理性吃瓜就上反差吃瓜局。",
    keywords: "反差吃瓜,反差吃瓜人设反转,反差吃瓜当事人,反差吃瓜前后对比,反差吃瓜局",
    canonicalPath: "/",
    jsonLd: [
      {
        "@context": "https://schema.org",
        "@type": "WebSite",
        name: SITE_NAME,
        alternateName: "反差吃瓜局",
        description: SITE_SLOGAN,
      },
      {
        "@context": "https://schema.org",
        "@type": "ItemList",
        name: "反差吃瓜反转档案",
        itemListElement: cases.map((c, i) => ({
          "@type": "ListItem",
          position: i + 1,
          name: `${c.person}：${c.title}`,
        })),
      },
      {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: siteFaqs.map((f) => ({
          "@type": "Question",
          name: f.q,
          acceptedAnswer: { "@type": "Answer", text: f.a },
        })),
      },
    ],
  });

  const handleCatChange = (key: string) => {
    const next = new URLSearchParams(searchParams);
    if (key === "all") next.delete("cat");
    else next.set("cat", key);
    setSearchParams(next, { replace: true });
  };

  return (
    <FanchaLayout>
      <Hero />
      <CasesSection cat={cat} q={q} onCatChange={handleCatChange} />
      <RankSection />
      <MethodSection />
      <LatestSection />
      <FaqSection />
      <ContributeSection />
    </FanchaLayout>
  );
}